import type { SupportedLocale } from './i18n/language-config.ts';
export function toLocaleString(value: number | undefined, locale: SupportedLocale, defaultEmpty = '-') {
    if (value === undefined) {
        return defaultEmpty;
    } else if (Number.isNaN(value)) {
        return defaultEmpty;
    }
    return new Intl.NumberFormat(locale).format(value);
}

export function toCurrencyString(value: number, locale: SupportedLocale, decimals = 0, currency = 'EUR') {
    return new Intl.NumberFormat(locale, {
        style: 'currency',
        currency,
        maximumFractionDigits: decimals,
    }).format(value);
}

export function toCurrencyStringOrEmpty(
    value: number | null | undefined,
    locale: SupportedLocale,
    decimals = 0,
    currency = 'EUR',
    defaultEmpty = '-',
) {
    return value !== null && value !== undefined
        ? toCurrencyString(value, locale, decimals, currency)
        : defaultEmpty;
}
